import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "1cb3f2d3-76af-401d-87b7-7eb9bab3b297",
  title:
    "Pfitzinger/Latter: 61 to 84 miles per week, 12-week schedule",
  sourceName: "Faster Road Racing: 5K to Half Marathon",
  sourceUrl: "https://www.amazon.com/gp/product/1450470459/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=1450470459&linkCode=as2&tag=codyhoover-20&linkId=6107e4706a5e1cc10836339bd7b312e0",
  raceType: "Half Marathon",
  units: "miles",
  workouts: [
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description:
        "Lacate threshold 10 miles w/ 16 min LT interval (jog 4 min recovery), 13 min LT interval",
      totalDistance: 10,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description:
        "General aerobic + speed 9 miles w/ 2 sets of 6x100m strides (jog 3 min between sets)",
      totalDistance: 9,
    },
    {
      description: "Endurance 14 miles",
      totalDistance: 14,
    },
    {
      description: "Rest or cross-training",
      totalDistance: 0,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description:
        "Lacate threshold 11 miles w/ 18 min LT interval (jog 4 min recovery), 16 min LT interval",
      totalDistance: 11,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description:
        "General aerobic + speed 10 miles w/ 6x12 sec uphill followed by 8x100m strides",
      totalDistance: 10,
    },
    {
      description: "Endurance 15 miles",
      totalDistance: 15,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description:
        "Lacate threshold 11 miles w/ 20min LT interval (jog 4 min recovery), 18 min LT interval",
      totalDistance: 11,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description:
        "General aerobic + speed 9 miles w/ 6x12 sec uphill followed by 8x100m strides",
      totalDistance: 9,
    },
    {
      description: "Progression long run 16 miles, last 2 miles @ LT",
      totalDistance: 16,
    },
    {
      description: "Recovery 4 miles",
      totalDistance: 4,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description:
        "General aerobic + speed 9 miles w/ 2 sets of 6x150m strides (jog 3 min between sets)",
      totalDistance: 9,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Recovery #5",
      totalDistance: 5,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description:
        "Lacate threshold 11 miles w/ 24 min LT interval (jog 4 min recovery), 18 min LT interval",
      totalDistance: 11,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Recovery 4 miles a.m., 4 miles p.m.",
      totalDistance: 8,
    },
    {
      description:
        "General aerobic + speed 10 miles w/ 2 sets of 6x100m strides (jog 3 min between sets)",
      totalDistance: 10,
    },
    {
      description: "Progression long run 16 miles, last 3 miles @ LT",
      totalDistance: 16,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description: "General aerobic 10 miles",
      totalDistance: 10,
    },
    {
      description:
        "V02Max 12 miles w/ 6x1,200m @ 3k-5k race pace (jog 50-90% interval time recovery)",
      totalDistance: 12,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Recovery 5 miles a.m., 4 miles p.m.",
      totalDistance: 9,
    },
    {
      description:
        "General aerobic + speed 10 miles w/ 8x12 sec uphill followed by 8x100m strides",
      totalDistance: 10,
    },
    {
      description: "Endurance 17 miles",
      totalDistance: 17,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description: "General aerobic 11 miles",
      totalDistance: 11,
    },
    {
      description:
        "Lactate Threshold 12 miles, 44 min change-of-pace tempo run: 4 min fast, 4 min stead, followed by 6x(2x2 min fast, 4 min stead)",
      totalDistance: 12,
    },
    {
      description: "Endurance 14 miles",
      totalDistance: 14,
    },
    {
      description: "Recovery 6 miles a.m., 4 miles p.m.",
      totalDistance: 10,
    },
    {
      description: "General aerobic + speed 10 miles w/ 10x100m strides",
      totalDistance: 10,
    },
    {
      description: "Progression long run 17 miles, last 3 miles @ LT",
      totalDistance: 17,
    },
    {
      description: "Recovery 6 miles a.m., 5 miles p.m.",
      totalDistance: 11,
    },
    {
      description:
        "General aerobic + speed 11 miles w/ 2 sets of 5x150m strides (jog 250m between intervals and 4 min between sets)",
      totalDistance: 11,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "Recovery 5 miles w/ 4x100m strides",
      totalDistance: 5,
    },
    {
      description: "8k-10k tune-up race, 12 miles",
      totalDistance: 12,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Recovery 5 miles a.m., 4 miles p.m.",
      totalDistance: 9,
    },
    {
      description: "General aerobic 11 miles",
      totalDistance: 11,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description:
        "V02Max 12 miles w/ 2x1,600m, 2x1,200m, 2x1,000m @ 3k-5k race pace (jog 50-90% interval time recovery)",
      totalDistance: 12,
    },
    {
      description: "Recovery 6 miles a.m., 5 miles p.m.",
      totalDistance: 11,
    },
    {
      description: "General aerobic 11 miles",
      totalDistance: 11,
    },
    {
      description: "Endurance 18 miles",
      totalDistance: 18,
    },
    {
      description: "Recovery 6 miles a.m., 5 miles p.m.",
      totalDistance: 11,
    },
    {
      description:
        "General aerobic + speed 11 miles w/ 2 sets of 5x150m strides (jog 250m recovery and 4 min between sets)",
      totalDistance: 11,
    },
    {
      description: "General aerobic 9 miles",
      totalDistance: 9,
    },
    {
      description: "General aerobic 7 miles",
      totalDistance: 7,
    },
    {
      description: "Recovery 5 miles w/ 4x100m strides",
      totalDistance: 5,
    },
    {
      description: "8k-10k tune-up race, 12 miles",
      totalDistance: 12,
    },
    {
      description: "Endurance 13 miles",
      totalDistance: 13,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description: "General aerobic 8 miles",
      totalDistance: 8,
    },
    {
      description: "Recovery 7 miles",
      totalDistance: 7,
    },
    {
      description:
        "V02Max 10 miles w/ 3x1,200m, 3x800m @ 3k-5k race pace (jog 50-90% interval time recovery)",
      totalDistance: 10,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description:
        "General aerobic + speed 9 miles w/ 2 sets of 6x100m strides (jog 3 min between sets)",
      totalDistance: 9,
    },
    {
      description: "Endurance 12 miles",
      totalDistance: 12,
    },
    {
      description: "Recovery 5 miles",
      totalDistance: 5,
    },
    {
      description:
        "Race pace + speed 9 miles w/  2 miles @ half marathon race pace and 6x100m strides",
      totalDistance: 9,
    },
    {
      description: "Recovery 7 miles",
      totalDistance: 7,
    },
    {
      description: "Recovery 6 miles",
      totalDistance: 6,
    },
    {
      description: "Rest",
      totalDistance: 0,
    },
    {
      description: "Recovery 4 miles w/ 4x100m strides",
      totalDistance: 4,
    },
    {
      description: "Half Marathon goal race 17 miles",
      totalDistance: 17,
    },
  ],
} as BuiltInPlan;
